import { render } from "./ProjetView.vue?vue&type=template&id=313ed693&scoped=true"
import script from "./ProjetView.vue?vue&type=script&lang=js"
export * from "./ProjetView.vue?vue&type=script&lang=js"

import "./ProjetView.vue?vue&type=style&index=0&id=313ed693&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313ed693"]])

export default __exports__